import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Badge } from '@wix/ambassador-badges-v3-badge/types';

import type { ThunkApiConfig } from '../../../types';

interface FetchAssignedBadgesResponse {
  badges: Badge[];
  assignedBadges: Badge[];
}

export const fetchAssignedBadges = createAsyncThunk<
  FetchAssignedBadgesResponse,
  string[],
  ThunkApiConfig
>(
  'badges/fetchAssignedBadges',
  async (assignedBadgeIds, { extra: { membersAboutMiddlewareService } }) => {
    return membersAboutMiddlewareService.getMemberBadges(assignedBadgeIds);
  },
);
